<template>
  <el-dialog
    class="updatePwd"
    title="修改密码"
    :visible.sync="visible"
    width="500px"
    :before-close="onClose"
  >
    <el-form :model="form" label-width="100px" :rules="rules" ref="updateForm">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          v-model="form.oldPassword"
          type="password"
          show-password
          autocomplete="off"
          placeholder="请输入旧密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="新密码">
        <el-input
          type="password"
          v-model="form.newPassword"
          show-password
          placeholder="请输入新密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="newPassword2">
        <el-input
          type="password"
          v-model="form.newPassword2"
          placeholder="请再次输入新密码"
          show-password
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose()">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" v-loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "UpdatePwd",
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      },
      loading: false,
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
          },
        ],
        newPassword2: [
          {
            required: true,
            message: "请再次输入新密码",
          },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs["updateForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http({
          url: "/modifyPwd",
          method: "put",
          data: this.form,
        })
          .then(() => {
            this.$emit("close");
            this.$message.success("修改成功");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
  watch: {
    visible: function (newData, oldData) {
      if (newData) {
        this.$refs["updateForm"].resetFields();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.updatePwd {
  .el-form {
    padding-right: 20px;
  }
}
</style>
